module.exports = __webpack_public_path__ + "static/media/Skarmory_gaussian2.1dda7950.png";